import config from '../../../helpers/config';
import React from 'react';
import LanguageSwitcher from '../Default/components/header/LanguageSwitcher';
import DarkThemeSwitcher from '../../DarkThemeSwitcher/DarkThemeSwitcher';
import WebSocketConnectionIndicator from '../../WebSocketConnectionIndicator/WebSocketConnectionIndicator';

export default function Footer() {
    return <div className="d-flex align-items-center">
        <div>
            &copy; {new Date().getFullYear()} {config('client.copyright')}
        </div>
        <div className="ms-auto d-flex align-items-center">
            <WebSocketConnectionIndicator className="me-2" offsetTop={6}/>

            <DarkThemeSwitcher className="me-2"/>

            <LanguageSwitcher toggleDropdownButtonClassName=""/>
        </div>
    </div>;
}
